import { RoleLabelsForExternal, Roles } from "../../providers/AuthContext";

const EXTERNAL_ROLES_WITH_ORG = [
    Roles.Partner,
    Roles.ServicePartner,
    Roles.CustomerService,
    Roles.CpmsLight,
];

export const shouldExternalUserBelongToOrganization = (role) =>
    EXTERNAL_ROLES_WITH_ORG.includes(role);

export const externalUserRoleOptions = Object.entries(RoleLabelsForExternal).map(
    ([key, label]) => ({
        value: Roles[key],
        label,
    })
);

export const mapOrganizationsToOptions = (orgs = []) =>
    orgs
        .filter((o) => o && o.organizationPublicId)
        .map(({ organizationPublicId, organizationName, name }) => ({
            value: organizationPublicId,
            label: organizationName || name || "",
        }));

export const formatTermsAccepted = (termsAccepted, t) =>
    termsAccepted === true
        ? (t ? t("common.yes") : "Yes")
        : (t ? t("common.no") : "No");

export const getExternalUserRoleOptions = (t) =>
    Object.entries(RoleLabelsForExternal).map(([key, label]) => ({
        value: Roles[key],
        label: t(`role.${key}`, { defaultValue: label }),
    }));